import React from 'react'
import Mail from 'globals/models/Mail'
import { SetState } from 'globals'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import MobileMail from 'components/MobileMail'

interface IProps {
  mails: Mail[],
  selectedMailsIds: React.Key[],
  setSelectedMailsIds: SetState<React.Key[]>,
  onMailClicked: (mail: Mail) => void
}

const ClientMailsMobile = (props: IProps) => {
  const { mails, selectedMailsIds, setSelectedMailsIds, onMailClicked } = props

  const onToggleMailSelection = (
      mailId: number,
      setSelectedMailsIds: SetState<React.Key[]>
  ) => (e: CheckboxChangeEvent) =>
    setSelectedMailsIds((selectedMails: React.Key[]) => {
      if (e.target.checked) {
        return selectedMails.concat([mailId])
      } else {
        return selectedMails.filter((mId) => mId !== mailId)
      }
    })

  return (
    <>
      {mails.map((mail) =>
        <MobileMail
          key={mail.id}
          mail={mail}
          selected={selectedMailsIds.includes(mail.id)}
          onChangeSelect={onToggleMailSelection(mail.id, setSelectedMailsIds)}
          onClick={onMailClicked}
          mailRef={(mail) => mail.id}
        />
      )}
    </>
  )
}

export default ClientMailsMobile
